export const environment = {
  production: false,
  version: "Dev_1.0",
  // apiUrl: "http://localhost:4000",
  apiUrl: "https://devapi.dairector.studio",
  // apiUrl: "https://api.dairector.studio",
};
